import { Component, OnInit } from '@angular/core';
import { DashboardLogicService } from '../../logic/dashboard.service';
import { PassDataService } from '../../services/pass-data.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'dashboard-pg',
  templateUrl: './dashboard.component.html',
})
export class DashboardPage implements OnInit {
  popup$: Observable<any> = new Observable<any>();

  constructor(
    private dashboardLogicService: DashboardLogicService,
    private passDataService: PassDataService
  ) {}

  ngOnInit(): void {
    this.dashboardLogicService.getAllSlokaTypesAndSlokas().subscribe();

    this.popup$ = this.passDataService.getPopup();
  }

  onPopupAction(e: string) {
    this.passDataService.setPopupAction(e);
  }
}
